import apiUtil from './apiUtil';

// Public plan/offer lookups used by the app shell and onboarding.
// Admin-only management calls live in adminApi.js.

let managementApi = {};

managementApi.getSpecialOffers = function () {
    let myData = {
        url: `/api/public/management/specialOffers`,
        method: 'GET',
    };
    return apiUtil.runRequest(myData);
};

managementApi.getSubscriptionTypesForPublic = function () {
    let myData = {
        url: `/api/public/subscriptionTypes`,
        method: 'GET',
    };
    return apiUtil.runRequest(myData);
};

export default managementApi;
